<script lang="ts">
	import type { MouseEventHandler } from 'svelte/elements';

	import { formatPrice, translateDynKey } from '$lib';
	import { m } from '$lib/paraglide/messages';
	import { getContext } from 'svelte';

	import FilterProvider from './store.svelte';

	const filterProvider = getContext<FilterProvider>('filter');

	const formatFilterButton = (name: string, value: string) => {
		switch (name) {
			case 'in_stock': {
				return m['attributes.shipped_in_24']();
			}
			case 'main_color_code': {
				return translateDynKey(`main_colors.${value}`, value);
			}
			default: {
				return filterProvider.displayValue(value);
			}
		}
	};
</script>

<div class="flex cursor-pointer flex-wrap gap-1">
	{#each Object.entries(filterProvider.checkedFilters) as [name, values], i (i)}
		{#if name === 'best_price'}
			{@render button(
				m.range({
					min: formatPrice(Number(values[0])),
					max: formatPrice(Number(values[1])),
				}),
				() => filterProvider.remove(name),
			)}
		{:else}
			{#each values as value (name + value)}
				{@render button(formatFilterButton(name, value), () => filterProvider.remove(name, value))}
			{/each}
		{/if}
	{/each}
	{#if filterProvider.getSelectedCount() > 1}
		<button
			type="button"
			class="w-fit cursor-pointer rounded-md bg-neutral-800 px-2 py-1 text-xs text-white transition-colors hover:bg-neutral-600"
			onclick={() => filterProvider.reset()}
		>
			{m.clear_filters()}
			<span class="close">✕</span>
		</button>
	{/if}
</div>

{#snippet button(content: string, onclick: MouseEventHandler<HTMLButtonElement>)}
	<button
		type="button"
		class="w-fit cursor-pointer rounded-md bg-neutral-200 px-2 py-1 text-xs transition-colors hover:bg-neutral-100"
		{onclick}
	>
		{content}
		<span class="close">✕</span>
	</button>
{/snippet}
